import { EquipmentType } from '../types';

export function equipmentTypeCorrection(softwareNumber: number, equipmentType: string): EquipmentType {
  const strengthSW = [424992, 424114, 111111];
  return strengthSW.indexOf(softwareNumber) !== -1 ? 'strength' : (equipmentType as EquipmentType);
}
